module.exports = __webpack_public_path__ + "img/home-hero.png?8e36162df170c340f56c06562ff34c20";